const DETAIL_LABELS = {
  request_body: 'Datos enviados',
  friendly_request_data: 'Datos enviados',
  query_params: 'Parametros de consulta',
  headers: 'Encabezados',
  exception: 'Error',
  route_params: 'Parametros de ruta',
  response_summary: 'Resumen de respuesta',
  login_response_summary: 'Resumen de inicio de sesion',
  register_response_summary: 'Resumen de registro',
  extend_session_response_summary: 'Resumen de extension de sesion',
  login_payload: 'Datos de inicio de sesion',
  register_payload: 'Datos de registro',
  refresh_token_masked: 'Token de renovacion (oculto)',
  recovery_request_email: 'Email de recuperacion',
  recovery_response_message: 'Respuesta de recuperacion',
  generated_contract_numbers: 'Contratos generados',
  processed_contract_numbers: 'Contratos con pago registrado',
  failed_contract_numbers: 'Contratos con error',
  entity_reference: 'Registro afectado',
  entity_changes: 'Cambios detectados',
  http_status: 'Codigo HTTP',
};

const DETAIL_FIELD_LABELS = {
  numberContract: 'Numero de contrato',
  contract_number: 'Numero de contrato',
  coefficient: 'Coeficiente',
  defermentPercentage: 'Porcentaje de diferimiento',
  excluded_contracts: 'Contratos excluidos',
  first_due_amount: '1er vencimiento (monto)',
  second_due_amount: '2do vencimiento (monto)',
  third_due_amount: '3er vencimiento (monto)',
  first_due_date: '1er vencimiento (fecha)',
  second_due_date: '2do vencimiento (fecha)',
  third_due_date: '3er vencimiento (fecha)',
  uuid_group: 'Grupo',
  uuid_plan: 'Plan',
  plan_uuid: 'Plan',
  uuid_payment_method: 'Forma de pago',
  payment_method_uuid: 'Forma de pago',
  uuid_contract: 'Contrato',
  contract_uuid: 'Contrato',
  uuid_allotment: 'Loteo',
  allotment_uuid: 'Loteo',
  uuid_lot: 'Lote',
  lot_uuid: 'Lote',
  uuid_construction_type: 'Tipo de construccion',
  construction_type_uuid: 'Tipo de construccion',
  estimated_delivery_date: 'Fecha estimada de entrega',
  uuid_subcontractor: 'Subcontratista',
  subcontractor_uuid: 'Subcontratista',
  uuid_legal_entity: 'Entidad legal',
  legal_entity_uuid: 'Entidad legal',
  uuid_pre_adjudication_reason: 'Motivo de preadjudicacion',
  pre_adjudication_reason_uuid: 'Motivo de preadjudicacion',
  uuid_release_reason: 'Motivo de liberacion',
  release_reason_uuid: 'Motivo de liberacion',
  uuid_district: 'Localidad',
  district_uuid: 'Localidad',
  uuid_marital_status: 'Estado civil',
  marital_status_uuid: 'Estado civil',
  uuid_nationality: 'Nacionalidad',
  nationality_uuid: 'Nacionalidad',
  uuid_bank_account: 'Cuenta bancaria',
  bank_account_uuid: 'Cuenta bancaria',
  uuid_movement_type: 'Tipo de movimiento',
  movement_type_uuid: 'Tipo de movimiento',
  uuid_movement_concept: 'Concepto de movimiento',
  movement_concept_uuid: 'Concepto de movimiento',
  uuid_payment_order: 'Orden de pago',
  payment_order_uuid: 'Orden de pago',
  uuid_sale_point: 'Punto de venta',
  sale_point_uuid: 'Punto de venta',
  uuid_branch: 'Sucursal',
  branch_uuid: 'Sucursal',
  uuid_project: 'Proyecto',
  project_uuid: 'Proyecto',
  project_id: 'Proyecto',
  uuid_task: 'Tarea',
  task_uuid: 'Tarea',
  task_id: 'Tarea',
  uuid_subscriber: 'Suscriptor',
  subscriber_uuid: 'Suscriptor',
  uuid_iva_condition: 'Condicion IVA',
  iva_condition_uuid: 'Condicion IVA',
  uuid_company: 'Empresa',
  company_uuid: 'Empresa',
  uuid_department: 'Departamento',
  department_uuid: 'Departamento',
  uuid_province: 'Provincia',
  province_uuid: 'Provincia',
  uuid_country: 'Pais',
  country_uuid: 'Pais',
  uuid_user: 'Usuario',
  uuid_user_gen: 'Usuario',
  uuid_user_issued: 'Usuario',
  uuid_user_che: 'Usuario',
  uuid_user_can: 'Usuario',
  uuid_user_who_linked: 'Usuario',
  user_uuid: 'Usuario',
  group_name: 'Grupo',
  plan_name: 'Plan',
  payment_method_name: 'Forma de pago',
  user_name: 'Usuario',
  requested_by: 'Solicitado por',
  excluded_contract_numbers: 'Contratos excluidos',
  excluded_contracts_count: 'Cantidad de contratos excluidos',
  coupon_descriptions: 'Detalle de cupones cobrados',
  count: 'Cantidad',
  omitted_count: 'Contratos omitidos',
  contract_numbers: 'Numeros de contrato',
  selected_coupons_count: 'Cupones seleccionados',
  registered_coupons_count: 'Cupones registrados',
  invoices_count: 'Facturas generadas',
  errors_count: 'Errores',
  payment_date: 'Fecha de cobro',
  payment_dates: 'Fechas de cobro',
  invoice_date: 'Fecha de factura',
  electronic_invoice: 'Factura electronica',
  collecting_entities: 'Entidades recaudadoras',
  collecting_entity: 'Entidad recaudadora',
  sale_point: 'Punto de venta',
  branch: 'Sucursal',
  billed_by: 'Facturado por',
  provider: 'Proveedor',
  file_name: 'Archivo',
  generated_coupons_count: 'Cupones generados',
};

const UUID_VALUE_PATTERN = /^[0-9a-f]{6,}(?:-[0-9a-f]{3,}){2,4}$/i;
const DATE_ONLY_PATTERN = /^\d{4}-\d{2}-\d{2}$/;
const DATETIME_PATTERN = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/;

const PRIORITY_FIELDS = [
  'contract_numbers',
  'registered_coupons_count',
  'errors_count',
  'invoices_count',
  'selected_coupons_count',
  'payment_date',
  'payment_dates',
  'count',
  'generated_coupons_count',
  'collecting_entity',
  'collecting_entities',
  'sale_point',
  'branch',
  'billed_by',
  'provider',
  'file_name',
  'group_name',
  'plan_name',
  'payment_method_name',
  'user_name',
  'requested_by',
  'excluded_contract_numbers',
  'coupon_descriptions',
  'omitted_count',
  'numberContract',
  'contract_number',
  'first_due_amount',
  'first_due_date',
  'second_due_amount',
  'second_due_date',
  'third_due_amount',
  'third_due_date',
];

const HIDDEN_DETAIL_FIELDS = new Set(['excluded_contracts']);
const INLINE_LIST_FIELDS = new Set([
  'contract_numbers',
  'excluded_contract_numbers',
  'coupon_descriptions',
]);
const TECHNICAL_ID_FIELD_PATTERN = /(^uuid$|^uuid_|_uuid$|_id$)/i;

const humanizeSnakeCase = (value) => {
  if (!value) return 'Detalle';
  const cleanValue = String(value).replace(/[-_]+/g, ' ').trim();
  if (!cleanValue) return 'Detalle';
  return cleanValue.charAt(0).toUpperCase() + cleanValue.slice(1);
};

const isNumericString = (value) =>
  typeof value === 'string' &&
  value.trim() !== '' &&
  !Number.isNaN(Number(value));

const isAmountField = (fieldKey) => {
  const lowerKey = String(fieldKey || '').toLowerCase();
  return (
    lowerKey.includes('amount') ||
    lowerKey.includes('monto') ||
    lowerKey.includes('total') ||
    lowerKey.includes('subtotal')
  );
};

const isPercentageField = (fieldKey) => {
  const lowerKey = String(fieldKey || '').toLowerCase();
  return lowerKey.includes('percentage') || lowerKey.includes('porcentaje');
};

const isUuidField = (fieldKey) => {
  const lowerKey = String(fieldKey || '').toLowerCase();
  return (
    lowerKey === 'uuid' ||
    lowerKey.startsWith('uuid_') ||
    lowerKey.endsWith('_uuid') ||
    lowerKey.endsWith('_id')
  );
};

const formatDateValue = (value) => {
  if (!value || typeof value !== 'string') return value;
  const source = DATE_ONLY_PATTERN.test(value) ? `${value}T00:00:00` : value;
  const parsedDate = new Date(source);
  if (Number.isNaN(parsedDate.getTime())) return value;
  if (DATE_ONLY_PATTERN.test(value)) return parsedDate.toLocaleDateString('es-AR');
  return parsedDate.toLocaleString('es-AR');
};

const formatPrimitiveValue = (value, fieldKey) => {
  if (value === null || value === undefined || value === '') return 'Sin dato';
  if (typeof value === 'boolean') return value ? 'Si' : 'No';

  if (typeof value === 'number') {
    if (isAmountField(fieldKey)) {
      return value.toLocaleString('es-AR', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    }
    return String(value);
  }

  if (typeof value === 'string') {
    const trimmedValue = value.trim();
    if (!trimmedValue) return 'Sin dato';

    if (trimmedValue.toLowerCase() === 'all') return 'Todos';
    if (trimmedValue.toLowerCase() === 'none') return 'Sin dato';

    if (DATE_ONLY_PATTERN.test(trimmedValue) || DATETIME_PATTERN.test(trimmedValue)) {
      return formatDateValue(trimmedValue);
    }

    if (isNumericString(trimmedValue)) {
      const numericValue = Number(trimmedValue);
      if (isAmountField(fieldKey)) {
        return numericValue.toLocaleString('es-AR', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
      }
      if (isPercentageField(fieldKey)) {
        return `${numericValue.toLocaleString('es-AR')}%`;
      }
      return trimmedValue;
    }

    return trimmedValue;
  }

  try {
    return JSON.stringify(value, null, 2);
  } catch (error) {
    return String(value);
  }
};

const resolveReferenceValue = (fieldKey, value, resolveReference) => {
  if (typeof resolveReference !== 'function') return null;
  try {
    return resolveReference(fieldKey, value);
  } catch (error) {
    return null;
  }
};

const formatDisplayPrimitive = (value, fieldKey, resolveReference) => {
  const resolvedValue = resolveReferenceValue(fieldKey, value, resolveReference);
  if (resolvedValue !== null && resolvedValue !== undefined && resolvedValue !== '') {
    return String(resolvedValue);
  }

  if (typeof value === 'string' && UUID_VALUE_PATTERN.test(value.trim())) {
    return 'Referencia no disponible';
  }

  return formatPrimitiveValue(value, fieldKey);
};

const formatDisplayArray = (fieldValue, fieldKey, resolveReference) => {
  if (!Array.isArray(fieldValue) || !fieldValue.length) return 'Sin dato';

  if (INLINE_LIST_FIELDS.has(fieldKey)) {
    return fieldValue.join(', ');
  }

  const parsedItems = fieldValue
    .map((item) => {
      if (isPlainDetailObject(item) || Array.isArray(item)) {
        return stringifyAuditDetailValue(item);
      }
      return formatDisplayPrimitive(item, fieldKey, resolveReference);
    })
    .filter((item) => item !== undefined && item !== null && item !== '');

  if (!parsedItems.length) return 'Sin dato';
  return parsedItems.join(', ');
};

const parseNestedJsonIfNeeded = (value) => {
  if (typeof value !== 'string') return value;
  const trimmedValue = value.trim();
  if (!trimmedValue) return value;
  if (!trimmedValue.startsWith('[') && !trimmedValue.startsWith('{')) return value;

  try {
    return JSON.parse(trimmedValue);
  } catch (error) {
    // Compatibilidad con payloads antiguos serializados con comillas simples.
    try {
      const normalized = trimmedValue.replace(/'([^']*)'/g, (_match, content) => {
        const escaped = String(content).replace(/"/g, '\\"');
        return `"${escaped}"`;
      });
      return JSON.parse(normalized);
    } catch (fallbackError) {
      return value;
    }
  }
};

const getDetailFieldPriority = (fieldKey) => {
  const index = PRIORITY_FIELDS.indexOf(fieldKey);
  return index >= 0 ? index : PRIORITY_FIELDS.length + 1;
};

const getDetailDisplayLabel = (label) => {
  if (!label) return 'Detalle';
  return DETAIL_LABELS[label] || humanizeSnakeCase(label);
};

const getDetailPriority = (label) => {
  const priorityByLabel = {
    friendly_request_data: 1,
    generated_contract_numbers: 2,
    processed_contract_numbers: 2,
    failed_contract_numbers: 3,
    response_summary: 4,
    request_body: 5,
    query_params: 6,
    headers: 7,
  };
  return priorityByLabel[label] || 99;
};

export const parseAuditDetailValue = (value) => {
  if (value === null || value === undefined) return null;
  if (typeof value !== 'string') return value;

  const trimmedValue = value.trim();
  if (!trimmedValue) return '';

  const startsAsJson = trimmedValue.startsWith('{') || trimmedValue.startsWith('[');
  if (!startsAsJson) return value;

  try {
    return JSON.parse(trimmedValue);
  } catch (error) {
    return value;
  }
};

export const isPlainDetailObject = (value) =>
  Boolean(value) && typeof value === 'object' && !Array.isArray(value);

const normalizeChangeEntry = (entry, index, resolveReference) => {
  const key = entry?.field || `field_${index + 1}`;
  const label = entry?.label || humanizeSnakeCase(key);

  return {
    key,
    label,
    before: formatDisplayPrimitive(entry?.before, key, resolveReference),
    after: formatDisplayPrimitive(entry?.after, key, resolveReference),
  };
};

const extractEntityReference = (parsedValue) => {
  if (!parsedValue) return null;
  if (typeof parsedValue === 'string') {
    return {
      display: parsedValue,
      metadata: null,
    };
  }
  if (typeof parsedValue !== 'object') {
    return {
      display: String(parsedValue),
      metadata: null,
    };
  }

  const display =
    parsedValue.display ||
    [parsedValue.entity_label, parsedValue.contract_number]
      .filter(Boolean)
      .join(' ') ||
    'Registro afectado';

  return {
    display,
    metadata: parsedValue,
  };
};

const toAdditionalDetail = (detail, index) => {
  const parsedValue = parseAuditDetailValue(detail?.value);
  return {
    id: detail?.id ?? `detail-${index}`,
    label: getDetailDisplayLabel(detail?.label),
    value: parsedValue,
  };
};

export const stringifyAuditDetailValue = (value) => {
  const sanitizeValue = (input, fieldKey = '') => {
    if (input === null || input === undefined || input === '') return input;

    if (typeof input === 'string') {
      const trimmed = input.trim();
      if (UUID_VALUE_PATTERN.test(trimmed)) return 'Referencia no disponible';
      return input;
    }

    if (Array.isArray(input)) return input.map((item) => sanitizeValue(item, fieldKey));

    if (isPlainDetailObject(input)) {
      const sanitized = {};
      Object.entries(input).forEach(([key, nestedValue]) => {
        if (TECHNICAL_ID_FIELD_PATTERN.test(String(key)) && typeof nestedValue === 'string') {
          const cleaned = nestedValue.trim();
          if (UUID_VALUE_PATTERN.test(cleaned)) return;
        }
        sanitized[key] = sanitizeValue(nestedValue, key);
      });
      return sanitized;
    }

    return input;
  };

  const normalizedValue = sanitizeValue(value);

  if (normalizedValue === null || normalizedValue === undefined || normalizedValue === '') return 'Sin dato';
  if (typeof normalizedValue === 'boolean') return normalizedValue ? 'Si' : 'No';
  if (typeof normalizedValue === 'string') return normalizedValue;
  if (typeof normalizedValue === 'number') return String(normalizedValue);
  try {
    return JSON.stringify(normalizedValue, null, 2);
  } catch (error) {
    return String(normalizedValue);
  }
};

export const toDetailObjectEntries = (value, options = {}) => {
  if (!isPlainDetailObject(value)) return [];
  const { resolveReference } = options;
  const hasCouponDescriptions =
    Array.isArray(value.coupon_descriptions) && value.coupon_descriptions.length > 0;

  return Object.entries(value)
    .filter(([fieldKey, entryValue]) => {
      if (entryValue === undefined || HIDDEN_DETAIL_FIELDS.has(fieldKey)) return false;
      if (hasCouponDescriptions && fieldKey === 'contract_numbers') return false;
      return true;
    })
    .sort(([leftKey], [rightKey]) => {
      const leftPriority = getDetailFieldPriority(leftKey);
      const rightPriority = getDetailFieldPriority(rightKey);
      if (leftPriority !== rightPriority) return leftPriority - rightPriority;
      return leftKey.localeCompare(rightKey);
    })
    .map(([fieldKey, fieldValue]) => {
      const normalizedFieldValue = parseNestedJsonIfNeeded(fieldValue);
      const displayLabel = DETAIL_FIELD_LABELS[fieldKey] || humanizeSnakeCase(fieldKey);

      const isObjectValue = isPlainDetailObject(normalizedFieldValue);
      const isArrayValue = Array.isArray(normalizedFieldValue);
      const isInlineList = INLINE_LIST_FIELDS.has(fieldKey) && isArrayValue;
      const resolvedValue = resolveReferenceValue(fieldKey, normalizedFieldValue, resolveReference);
      const isUnresolvedTechnicalReference =
        isUuidField(fieldKey) &&
        typeof normalizedFieldValue === 'string' &&
        UUID_VALUE_PATTERN.test(normalizedFieldValue.trim()) &&
        !resolvedValue;

      if (isUnresolvedTechnicalReference) return null;

      const isCodeValue =
        (typeof normalizedFieldValue === 'string' &&
          !resolvedValue &&
          (UUID_VALUE_PATTERN.test(normalizedFieldValue) || isUuidField(fieldKey))) ||
        isObjectValue ||
        (isArrayValue && !isInlineList);

      const displayValue =
        isInlineList
          ? normalizedFieldValue.join(', ')
          : resolvedValue !== null && resolvedValue !== undefined && resolvedValue !== ''
          ? String(resolvedValue)
          : isObjectValue
          ? stringifyAuditDetailValue(normalizedFieldValue)
          : isArrayValue
          ? formatDisplayArray(normalizedFieldValue, fieldKey, resolveReference)
          : formatDisplayPrimitive(normalizedFieldValue, fieldKey, resolveReference);

      return {
        key: fieldKey,
        label: displayLabel,
        value: displayValue,
        isCodeValue,
      };
    })
    .filter(Boolean);
};

export const parseAuditDetails = (action, options = {}) => {
  const { resolveReference } = options;
  const details = Array.isArray(action?.details) ? action.details : [];

  let changes = [];
  let changeSummary = null;
  let entityReference = null;
  let additionalDetails = [];

  details.forEach((detail, index) => {
    const parsedValue = parseAuditDetailValue(detail?.value);
    const label = detail?.label;

    if (label === 'entity_changes' && parsedValue && typeof parsedValue === 'object') {
      const parsedFields = Array.isArray(parsedValue.fields) ? parsedValue.fields : [];
      changes = parsedFields.map((entry, index) =>
        normalizeChangeEntry(entry, index, resolveReference)
      );
      changeSummary = {
        count:
          typeof parsedValue.count === 'number'
            ? parsedValue.count
            : parsedFields.length,
        message: parsedValue.message || '',
      };
      return;
    }

    if (label === 'entity_reference') {
      entityReference = extractEntityReference(parsedValue);
      return;
    }

    additionalDetails.push({
      ...toAdditionalDetail(detail, index),
      rawLabel: label || '',
    });
  });

  const httpMethod = (action?.http_method || '').toUpperCase();
  if (!changes.length && (httpMethod === 'PUT' || httpMethod === 'PATCH')) {
    const hasRequestBody = details.some((detail) => detail?.label === 'request_body');
    if (hasRequestBody) {
      changeSummary = {
        count: 0,
        message:
          'Esta accion no guardo snapshot historico para comparar antes y despues.',
      };
    }
  }

  additionalDetails = additionalDetails.sort((left, right) => {
    const priorityDiff = getDetailPriority(left.rawLabel) - getDetailPriority(right.rawLabel);
    if (priorityDiff !== 0) return priorityDiff;
    return String(left.label).localeCompare(String(right.label));
  });

  const hasFriendlyRequestData = additionalDetails.some(
    (detail) => detail.rawLabel === 'friendly_request_data'
  );

  if (hasFriendlyRequestData) {
    additionalDetails = additionalDetails.filter((detail) => detail.rawLabel !== 'request_body');
  }

  return {
    changes,
    changeSummary,
    entityReference,
    additionalDetails,
  };
};
